<template>
  <div class="cat-empty flex flex-col justify-center items-center select-none">
    <cat-icon v-if="iconType === 'data'" name="icon-illustration_data" prefix="iconfont_emo"></cat-icon>
    <cat-icon v-if="iconType === 'image'" name="icon-photo" prefix="iconfont_emo"></cat-icon>
    <cat-icon v-if="iconType === 'attachment'" name="icon-illustration_attachment" prefix="iconfont_emo"></cat-icon>
    <cat-icon v-if="iconType === 'building'" name="icon-building" prefix="iconfont_emo"></cat-icon>
    <cat-icon
      v-if="iconType === 'construction'"
      name="queshengtu_shigongjianshezhong"
      prefix="iconfont_zcpc"
    ></cat-icon>
    <slot v-if="iconType === 'custom'" name="icon"></slot>

    <div class="text-base mt-4px">{{ title }}</div>
    <div class="inline-flex text-base mt-4px text-[var(--color-text-placeholder)]">
      <slot name="tip"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
interface PropsType {
  title?: string;
  iconType?: 'data' | 'image' | 'custom' | 'construction' | 'attachment' | 'building';
}
const props = withDefaults(defineProps<PropsType>(), {
  title: '暂无数据',
  iconType: 'data',
});
const { iconType } = toRefs(props);
</script>
<style lang="scss" scoped>
.cat-empty img {
  width: 80px;
  height: 80px;
}

.cat-icon {
  width: 64px;
  height: 64px;
  font-size: 64px;
  margin-top: 24px;
}

.el-link,
el-upload,
el-button {
  font-size: medium;
}
</style>
